import { IoGameController } from "react-icons/io5";
// import { FaAtlassian } from "react-icons/fa";
import { IoDocumentText } from "react-icons/io5";
import resume from "../assets/documents/resume.pdf";
import { RESUME_LAST_UPDATED } from "../system/appConfig";
import TrackedLink from "./TrackedLink";

function Job({ title, startYear, endYear, icon, border }) {
  return (
    <div className={`flex flex-row justify-center items-center py-7 ${border && "job-border"}`}>
      <div className="mr-4 job-icon-container">{icon}</div>
      <div className="flex flex-col flex-1 justify-center">
        <div>
          <h4>{title}</h4>
        </div>
        <div>
          <p className="light-text">
            {startYear} - {endYear}
          </p>
        </div>
      </div>
    </div>
  );
}

function WorkExperience({ bg }) {
  const io_icon_size = 50;

  const work_experience = [
    {
      title: "Director of Product at Zynga",
      startYear: "2023",
      endYear: "Present",
      icon: <IoGameController size={io_icon_size} />,
    },
    {
      title: "Lead Product Manager at Zynga",
      startYear: "2021",
      endYear: "2023",
      icon: <IoGameController size={io_icon_size} />,
    },
    {
      title: "Senior Product Manager at Zynga",
      startYear: "2020",
      endYear: "2021",
      icon: <IoGameController size={io_icon_size} />,
    },
    {
      title: "Product Manager at Zynga",
      startYear: "2018",
      endYear: "2020",
      icon: <IoGameController size={io_icon_size} />,
    },
  ];

  return (
    <div className="section-container" style={{ backgroundColor: bg }}>
      <div className="content-container xl:flex-row">
        <div className="mt-2 xl:flex-1 xl:mr-8 xl:flex xl:flex-col xl:justify-between">
          <div className="">
            <h3>Career</h3>
          </div>
          <div className="mt-6 mb-7 xl:mb-0 xl:flex-1">
            <p className="dark-text">
              {
                "I build systems that help teams move fast, make smart decisions, and ship features users actually want to engage with. My work spans experimentation frameworks, personalization engines, and internal tools—all designed to support better products and more enjoyable user experiences. I mix data, product instinct, and a love of solving hard problems."
              }
            </p>
          </div>
          <div className="my-8">
            <div className="button-2">
              <TrackedLink href={resume} target="_blank" rel="noreferrer" kingdom="resume" phylum={RESUME_LAST_UPDATED}>
                <div className="flex-1">
                  <div className="flex items-center justify-center">
                    <IoDocumentText size={24} className="mr-2" />
                    <h4>Resume</h4>
                  </div>
                </div>
              </TrackedLink>
            </div>
          </div>
        </div>
        <div className="mt-2 xl:flex-1 xl:ml-8">
          <div className="">
            <h3>Work Experience</h3>
          </div>
          <div className="">
            {work_experience.map((job, index) => (
              <Job
                key={`${index}_${job.title}`}
                title={job.title}
                startYear={job.startYear}
                endYear={job.endYear}
                icon={job.icon}
                border={index !== work_experience.length - 1}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkExperience;
